import React from 'react';

export type SiteLogoVariant = 'default' | 'inverse';

type SiteLogoProps = {
  size?: number;
  className?: string;
  variant?: SiteLogoVariant;
};

const BRAND_PRIMARY = '#0284C7';
const BRAND_DEEP = '#0C4A6E';

const SiteLogo: React.FC<SiteLogoProps> = ({
  size = 40,
  className = '',
  variant = 'default',
}) => {
  const radius = Math.round(size * 0.22);
  const isInverse = variant === 'inverse';
  const background = isInverse ? '#FFFFFF' : BRAND_PRIMARY;
  const stroke = isInverse ? BRAND_DEEP : '#FFFFFF';
  const nodeFill = isInverse ? BRAND_PRIMARY : '#FFFFFF';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      width={size}
      height={size}
      fill="none"
      role="img"
      aria-hidden="true"
      className={`shrink-0 ${className}`}
    >
      <rect width="40" height="40" rx={radius} fill={background} />

      <g
        stroke={stroke}
        strokeWidth="1.45"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Left circuit node */}
        <circle cx="9.4" cy="20" r="2.75" />
        <path d="M9.4 17.1V14.6" />
        <path d="M6.9 20H8.2" />
        <path d="M9.4 22.9V25.4" />

        {/* Interlocking opportunity loop */}
        <path d="M12.2 20C12.2 15.1 15.8 13.4 18.4 16.1C19.8 17.6 20.8 17.6 22.2 16.1C24.8 13.4 28.4 15.1 28.4 20C28.4 24.9 24.8 26.6 22.2 23.9C20.8 22.4 19.8 22.4 18.4 23.9C15.8 26.6 12.2 24.9 12.2 20Z" />

        {/* Right network node */}
        <circle cx="30.6" cy="20" r="3.15" />
        <circle cx="30.6" cy="20" r="1.45" />
      </g>

      <circle cx="9.4" cy="20" r="0.85" fill={nodeFill} />
    </svg>
  );
};

export default SiteLogo;
